import 'firebase/compat/remote-config'
import 'firebase/compat/messaging'
import {initializeApp} from 'firebase/app'

import {getMessaging, getToken, onMessage} from 'firebase/messaging'
import {getRemoteConfig, fetchAndActivate, getValue} from 'firebase/remote-config'

import {configuration} from '../../configuration'

export default {

    remoteConfig: {},

    remoteData: {},

    proxy: {},

    messagingToken: '',

    messaging: {},

    firebaseApp: {},

    init: function () {

        // REMOTE-CONFIG

        this.proxy = new Proxy(this.remoteData, {})

        const firebaseConfig = configuration.firebaseConfig

        this.firebaseApp = initializeApp(firebaseConfig)

        const remoteConfig = getRemoteConfig(this.firebaseApp)

        remoteConfig.settings.minimumFetchIntervalMillis = 3600000
        remoteConfig.settings.fetchTimeoutMillis = 60000
        remoteConfig.defaultConfig = {}

        fetchAndActivate(remoteConfig)
            .then(() => {

                this.proxy.data = remoteConfig.getAll()

            })
            .catch(() => {
            })

        this.remoteConfig = remoteConfig

        // MESSAGING

        this.messaging = getMessaging(this.firebaseApp)
        getToken(this.messaging, {vapidKey: configuration.firebaseConfig.cloudMessagingCertificat})
            .then((currentToken) => {
                if (currentToken) {
                    this.messagingToken = currentToken
                }
            }).catch(() => {})

        onMessage(this.messaging, (payload) => {
            return self.registration.showNotification(payload.title)
        })

    },


    async getValue(key, type) {

        return await new Promise(resolve => {

            //if remote is initialized
            if(this.remoteConfig.settings) {
                const value = getValue(this.remoteConfig, key)
                if (value['_source'] === 'remote') {
                    resolve(this.extractData(value['_value'], type))

                } else {
                    this.loopGetValue(key, type, resolve)
                }
            } else {
                this.loopGetValue(key, type, resolve)
            }
        })

    },

    loopGetValue(key, type, resolve) {
        setTimeout(() => {
            resolve(this.getValue(key, type))
        }, 10)
    },

    getAll() {

        return this.remoteConfig.fetchAndActivate()
            .then(() => {

                return this.remoteConfig.getAll()

            })
            .catch(() => {
            })

    },

    extractData(data, type) {
        if (data) {
            switch (type) {
                case this.TYPES.NUMBER:
                    return parseInt(data, 10)
                case this.TYPES.BOOLEAN:
                    return data === 'true'
                case this.TYPES.OBJECT:
                    return JSON.parse(data)
                default:
                    return data
            }
        }
    },

    TYPES: {
        STRING: 'String',
        NUMBER: 'Number',
        BOOLEAN: 'Boolean',
        OBJECT: 'Object'
    }
}
